import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { TooltipComponent, GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { useAppContext } from '../../../../providers/AppProvider';
import { Card } from 'react-bootstrap';
import React from 'react';

// Register eCharts components
echarts.use([TooltipComponent, GridComponent, BarChart, CanvasRenderer]);

// Interface for LLM Bias Data
export interface BiasLLMDataItem {
  Metric: string;
  Score: number;
  Assessment: string;
}

interface BiasLLMChartProps {
  data: BiasLLMDataItem[];
  title: string;
  description: string;
}

const BiasLLMChart: React.FC<BiasLLMChartProps> = ({
  data,
  title,
  description
}) => {
  const { getThemeColor } = useAppContext() || {};

  console.log('LLM DATA', data);

  // Safe function to fetch theme color with fallback
  const safeGetThemeColor = (key: string, fallback: string) => {
    if (typeof getThemeColor === 'function') {
      const color = getThemeColor(key);
      return typeof color === 'string' && color.trim() !== ''
        ? color
        : fallback;
    }
    return fallback;
  };

  // Theme colors with safe fallbacks
  const primaryColor = safeGetThemeColor('primary', '#007bff');
  const secondaryColor = safeGetThemeColor('secondary-color', '#6c757d');
  const tooltipBgColor = safeGetThemeColor('body-highlight-bg', '#ffffff');
  const tooltipBorderColor = safeGetThemeColor('border-color', '#ddd');
  const textColor = safeGetThemeColor('light-text-emphasis', '#000');

  console.log('Resolved Theme Colors:', {
    primaryColor,
    secondaryColor,
    tooltipBgColor,
    tooltipBorderColor,
    textColor
  });

  // Extract metrics and scores from the data
  const metrics = data.map(item => item.Metric);
  const scores = data.map(item => item.Score);

  const options = {
    color: primaryColor,
    tooltip: {
      trigger: 'axis',
      backgroundColor: tooltipBgColor,
      borderColor: tooltipBorderColor,
      textStyle: { color: textColor },
      formatter: (params: any) => {
        const param = params[0];
        return `<strong>${param.name}:</strong> ${param.value}`;
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: metrics,
      axisLabel: { rotate: 45, color: secondaryColor },
      axisLine: { lineStyle: { color: tooltipBorderColor } }
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: Math.max(...scores, 5),
      interval: 1,
      axisLabel: { formatter: '{value}', color: secondaryColor },
      axisLine: { lineStyle: { color: tooltipBorderColor } }
    },
    series: [
      {
        type: 'bar',
        data: scores,
        barWidth: '50%',
        itemStyle: { color: primaryColor }
      }
    ]
  };

  return (
    <Card className="h-100">
      <Card.Body>
        <h4>{title}</h4>
        <p>{description}</p>
        <ReactEChartsCore
          echarts={echarts}
          option={options}
          style={{ height: '400px' }}
        />
      </Card.Body>
    </Card>
  );
};

export default BiasLLMChart;
